import styled from 'styled-components'
import { Theme } from '@pga/pga-component-library'
import { FormGroup } from 'reactstrap'

export const InputWrapper = styled.div.attrs({ className: 'form-group' })`
  input {
    border: none;
    height: 100%;
    padding: 0.3rem 1.5rem;

    ::placeholder {
      color: ${Theme.colors.blueGrey};
      font-family: ${Theme.fonts.Montserrat};
      font-size: 16px;
      font-weight: 400;
    }
  }
  .ais-SearchBox-reset {
    padding: 1rem;
  }
  .ais-SearchBox-submit {
    padding: 0 8px;
  }
`

export const SuggestionWrapper = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #efefef;
  font-family: Montserrat;
  cursor: pointer;

  :hover {
    background: #efefef;
  }

  .span-light {
    opacity: .5;
    padding-left: 4px;
  }
`

export const DropdownResultsWrapper = styled.span.attrs({ className: 'ap-dropdown-menu ap-with-places' })`
  position: absolute;
  top: 100%;
  left: 0px;
  right: auto;
  display: block;
  z-index: 100;

  width: 100%;
  background: #ffffff;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  margin-top: 3px;
  overflow: hidden;
  
  .ap-suggestion {
    padding: 16px;
    display: flex;
    justify-content: space-between;
  }
  span {
    white-space: normal;
  }
`

export const ClearWrapper = styled.div`
  display: flex;
  align-items: center;
  top: 0;
  right: 0;
  position: absolute;
  padding: 10px;
  height: 100%;
`

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`

export const StyledInputWrapper = styled(FormGroup)`
  min-width: 100%;
`

export const StyledInput = styled.input`
  .input {
    width: 100%;
  }
`
